export function saveToLocalStorage(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function loadFromLocalStorage(key, defaultValue = '{}') {
  return JSON.parse(localStorage.getItem(key) || defaultValue);
}

export function removeFromLocalStorage(key) {
  localStorage.removeItem(key);
}